import { useState, useRef } from 'react';
import { Upload, X, Loader2, Image } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImageUpload({ value, onChange, label = "Image", token }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { alert('Fichier trop volumineux (max 5 Mo)'); return; }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await axios.post(`${API}/upload`, formData, {
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      const fullUrl = `${API}/files/${data.path}`;
      onChange(fullUrl);
    } catch (err) {
      alert(err.response?.data?.detail || "Erreur d'upload");
    } finally { setUploading(false); }
  };

  return (
    <div>
      <p className="text-xs text-[#E2E8F0] font-medium mb-1.5">{label}</p>
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="Upload" className="h-20 rounded-lg object-cover border border-white/10" 
            onError={e => { e.target.style.display = 'none'; }} />
          <button onClick={() => onChange('')}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#EF4444] flex items-center justify-center hover:bg-red-400 transition-colors">
            <X className="w-3 h-3 text-white" />
          </button>
        </div>
      ) : (
        <button onClick={() => inputRef.current?.click()} disabled={uploading}
          className="flex items-center gap-2 px-4 py-3 rounded-xl border border-dashed border-white/15 hover:border-[#7C3AED]/40 bg-white/[0.03] hover:bg-[#7C3AED]/5 transition-all text-sm text-[#94A3B8] hover:text-white w-full justify-center"
          data-testid="upload-btn">
          {uploading
            ? <><Loader2 className="w-4 h-4 animate-spin" /> Upload en cours...</>
            : <><Upload className="w-4 h-4" /> Choisir une image</>}
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
    </div>
  );
}
